import styled from 'styled-components';

import SetToManualFlow from './component';

export default styled(SetToManualFlow)`
  .radios {
    margin-top: 16px;
    margin-bottom: 24px;
  }

  .textarea {
    margin-top: 8px;
    > div {
      width: 320px;
      textarea {
        height: 64px;
      }
    }
  }

  .button-container {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;
